import usePlatformAchievement from "../hooks/usePlatformAchievement";

const PlatformAchievements = () => {
  const { sectionRef, stats, counts } = usePlatformAchievement();

  return (
    <section
      ref={sectionRef}
      className="flex flex-col items-center w-full"
    >
      <h1 className="text-2xl md:text-3xl font-bold text-primary font-qomra mb-12 text-center w-full max-w-screen-xl px-6">
        إنجازات المنصة
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-screen-xl px-6">
        {stats.map(({ id, label, icon }, index) => (
          <div
            key={id}
            className="bg-light shadow-lg rounded-2xl p-4 flex flex-col justify-between w-full text-right h-[140px] md:h-[180px] transition hover:shadow-xl"
          >
            {/* الأيقونة + الليبل */}
            <div className="flex items-center gap-2 mb-1 text-primary w-full">
              <div className="bg-liteGray rounded-full p-3 flex items-center justify-center flex-shrink-0">
                <img
                  src={icon}
                  alt={label}
                  className="w-8 h-8 md:w-10 md:h-10"
                  loading="lazy"
                />
              </div>

              <p className="text-base md:text-xl font-bold flex-1 text-right leading-snug">
                {label}
              </p>
            </div>

            {/* الرقم */}
            <h2 className="text-xl md:text-3xl font-bold font-qomra text-primary pr-[68px] mb-3">
              {Math.floor(counts[index])}
            </h2>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlatformAchievements;
